export default "__VITE_ASSET__CVowBdEw__"